import pipe from 'lodash/fp/pipe'
import zipObject from 'lodash/fp/zipObject'
import * as Utils from '../../utils'
import * as Constants from './constants'

export const verbs = [
  Constants.CLOSE,
  Constants.OPEN,
  Constants.LOAD,
  Constants.TOGGLE,
]

const createConstantMap = zipObject(verbs)
export const createConstants = Utils.createConstants(verbs, Constants.NOUN + '/')

export interface ConstantsMap {[key: string]: string}
export type CreateConstantsMap = (prefix: string) => ConstantsMap
export const createConstantsMap: CreateConstantsMap = pipe(
  createConstants,
  createConstantMap,
)



// WEBPACK FOOTER //
// ./src/components/detail-panel/utils.ts